export const tempLegalAccounts = {
  'admin': '5ji6ru04ej03xu3',
  'abl': 'l45.561;4',
  'ablscout': '12345678',
  'australianfang': 'z;m4g/gj94ek',
  'testuser1': 'hk4g45;4cl41'
}

export const accountIdMap = {
  'admin': 'SI000001',
  'testuser1': 'SI000002',
  'ablscout': 'SI000003',
  'australianfang': 'AF000001',
  'abl': 'AB000001',
}
